<app-logo-bar></app-logo-bar>
<app-nav-bar></app-nav-bar>
<router-outlet></router-outlet>
<app-footer></app-footer>